import axios from 'axios';
import { IHistoryCollectionDto } from 'entities/History/History.models';

const basePath = '/events';

export const historyListService = {
  getHistory: (eventId: number): Promise<IHistoryCollectionDto> => axios.get(`${basePath}/${eventId}/histories`),
};
